import { IUsersWorkplace } from 'core/interfaces/userInterface';
import { apiService } from 'core/services/apiService';
import { getEnrichedWorkplaceUsers } from 'core/utils/enrichWorkplaceUsers';
import { User, UserMe } from 'types';
import { Participant } from './broadcast';

/**
 * @deprecated Use getEnrichedWorkplaceUsers(workplaceId) instead.
 * Fetches a single user by ID — was incorrectly used as a workplace user list.
 */
const GetUsersList = async (workplaceId: number): Promise<User[]> => {
	const { ...data } = apiService.responseHandler(
		await apiService.get(`users/${workplaceId}`)
	);
	return [data];
};

/**
 * Fetches the list of workplaces associated with the current user.
 * @returns An array of {@link IUsersWorkplace} objects.
 */
const GetUsersWorkplacesList = async (): Promise<IUsersWorkplace[]> => {
	const { ...data } = apiService.responseHandler(
		await apiService.get(`users/workplaces`)
	);
	return [data];
};

/**
 * Fetches workplace users and maps them to the {@link Participant} shape
 * used by broadcast and messaging features.
 */
const GetParticipantsList = async (workplaceId: number): Promise<Participant[]> => {
	const users = await getEnrichedWorkplaceUsers(workplaceId);

	return users.map((user) => ({
		id: user.id,
		first_name: (user.firstName ?? '').trim(),
		last_name: (user.lastName ?? '').trim(),
		email: user.email || '',
	}));
};

/**
 * Fetches a single user's profile by ID.
 * @param userId - The numeric ID of the user.
 * @returns The {@link UserMe} profile object.
 */
const getUser = async (userId: number): Promise<UserMe> => {
	const data = apiService.responseHandler(await apiService.get(`users/${userId}`));
	return data;
};

export { GetParticipantsList, getUser, GetUsersList, GetUsersWorkplacesList };
